<!-- 编辑供应商 -->
<template>
  <div>
    <setDialog
      dialog-title="供应商评分"
      :center-dialog-visible="scoreVisible"
      :popup-width="'760px'"
      @resetPopupData="setResetPopupData"
      @submitPopupData="setSubmitPopupData"
    >
      <div class="supplier-name">
        <span>供应商名称：</span>
        <span>{{ scoreInfo.supplier }}</span>
      </div>
      <e-table
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="true"
      >
        <template slot="评分">
          <div><span style="color: #f0250f">*</span>评分</div>
        </template>

        <template #grade="slot">
          <div>
            <el-input
              v-model="slot.scope.row.grade"
              @input="checkNum(slot.scope.row, slot.scope.row.grade)"
            ></el-input>
          </div>
        </template>
      </e-table>
      <div class="score-wrap">
        <span>综合得分:</span>
        <span>{{ score }}分</span>
      </div>
    </setDialog>
  </div>
</template>

<script>
import setDialog from '@/components/common/epecDialog';
import ETable from '../../../components/common/e-table-list.vue';

export default {
  components: { setDialog, ETable },
  props: {
    // scoreInfo: {
    //   type: Object,
    //   default: () => {
    //     return {};
    //   },
    // },
    scoreVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      score: 0,
      loading: false,
      setVisible: true,
      tableData: [
        {
          item: '价格',
          weight: '25%',
          content:
            '非常好(90-100分)、较好(80-89分)、一般(70-79分)、较差(0-69分)',
          score: '0-100',
          grade: null,
          type: 'price',
        },
        {
          item: '商品质量',
          weight: '25%',
          content:
            '非常好(90-100分)、较好(80-89分)、一般(70-79分)、较差(0-69分)',
          score: '0-100',
          grade: null,
          type: 'productQuanlity',
        },
        {
          item: '服务',
          weight: '25%',
          content:
            '非常好(90-100分)、较好(80-89分)、一般(70-79分)、较差(0-69分)',
          score: '0-100',
          grade: null,
          type: 'service',
        },
        {
          item: '效率',
          weight: '25%',
          content:
            '非常好(90-100分)、较好(80-89分)、一般(70-79分)、较差(0-69分)',
          score: '0-100',
          grade: null,
          type: 'efficiency',
        },
      ],
      tableLabel: [
        {
          label: '考评项目',
          align: 'center',
          param: 'item',
          // width: "60",
        },
        {
          label: '权重',
          align: 'center',
          param: 'weight',
          // width: "60",
        },
        {
          label: '考核内容描述',
          align: 'center',
          param: 'content',
          width: '300',
        },
        {
          label: '分值',
          align: 'center',
          param: 'score',
          // width: "60",
        },
        {
          label: '评分',
          align: 'center',
          param: 'grade',
          slot: 'grade',
          // width: "60",
          header: true,
        },
      ],
      formLabelWidth: '130px',
      scoreInfo: {},
    };
  },

  computed: {},

  created() {},
  methods: {
    setTableDataScore(val) {
      console.log(val);
      this.scoreInfo = val;
      this.score = 0;
      this.tableData.forEach((item) => {
        console.log(this.scoreInfo[item.type]);
        item.grade =
          this.scoreInfo[item.type] === 0
            ? this.scoreInfo[item.type]
            : this.scoreInfo[item.type] !== null &&
              this.scoreInfo[item.type] !== undefined
            ? this.scoreInfo[item.type]
            : null;
        this.score +=
          item.grade !== null && item.grade != ''
            ? parseFloat(item.grade) * 0.25
            : 0;
      });
      this.score = this.score.toFixed(2);
      console.log(this.tableData);
    },
    checkNum(val, row) {
      const reg = /^(?:0|[1-9][0-9]?|100)(\.[0-9]{0,2})?$/;
      if (!reg.test(row)) {
        val.grade = '';
        this.$message.warning('请输入0-100的数值');
        return;
      }
      console.log(reg.test(row));
      //   if (!value.match(reg)) {
      //     return value=0;
      //   } else {
      //       console.log(value);
      //     return value;
      //   }
      this.score = 0;
      this.tableData.map((item) => {
        this.score +=
          item.grade !== null && item.grade != ''
            ? parseFloat(item.grade) * 0.25
            : 0;
      });
      this.score = this.score.toFixed(2);
    },
    setResetPopupData() {
      this.$emit('resetPopupData', 2);
    },
    setSubmitPopupData() {
      console.log(this.tableData);
      const score = this.checkScoreIsEmpty(this.tableData);
      if (score !== null) {
        this.$message.warning(`${score}评分不能为空`);
        return;
      }
      this.$emit('submitPopupData', {
        data: this.tableData,
        score: this.score,
        supplierId: this.scoreInfo.supplierId,
        id: this.scoreInfo.id,
        companyId: this.scoreInfo.companyId,
      });
    },
    checkScoreIsEmpty(arr) {
      let str = null;
      const len = arr.length;
      for (let i = 0; i < len; i++) {
        if (arr[i].grade === null || arr[i].grade === '') {
          str = arr[i].item;
          break;
        }
      }
      return str;
    },
  },
};
</script>
<style lang="scss" scoped>
.supplier-name {
  line-height: 1;
  margin: 0 0 20px 0;
  &:first-child {
  }
}
.score-wrap {
  width: 100%;
  height: 40px;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  background: #ddd;
}
</style>
